import { StatusIcon } from "./StatusIcon";
import { getStatusColor } from "../utils";
import { capitalize } from "@gettactic/helpers";

interface StatusDisplayProps {
  status: string;
  showIcon?: boolean;
  className?: string;
  iconClassName?: string;
}

export const StatusDisplay = ({ 
  status, 
  showIcon = true, 
  className = "",
  iconClassName = "h-4 w-4"
}: StatusDisplayProps) => {
  const capitalizedStatus = capitalize(status);
  
  return (
    <div className={`flex items-center space-x-1 ${className}`}>
      {showIcon && <StatusIcon status={capitalizedStatus} className={iconClassName} />}
      <span className={getStatusColor(status)}>
        {capitalizedStatus}
      </span>
    </div>
  );
};
